import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  shifts: [], // Initial shifts array
  isDefaultSet: false, // Initial isDefaultSet state
};

const shiftSlice = createSlice({
  name: 'shift',
  initialState,
  reducers: {
    setShifts: (state, action) => {
      state.shifts = action.payload;
      state.isDefaultSet = action.payload.some((shift) => shift.isDefault);
    },
    addShift: (state, action) => {
      state.shifts.push(action.payload);
      if (action.payload.isDefault) {
        state.isDefaultSet = true;
      }
    },
    updateShift: (state, action) => {

      const updatedShift = action.payload;

      const prevShift = state.shifts.find(shift => shift.id === updatedShift.id );

      let updatedPrevShifts = state.shifts;

      if ( ! prevShift.isDefault && updateShift.isDefault ) {
        // Set isDefault to false for previous default shifts
        updatedPrevShifts = state.shifts.map((prevShift) =>
          prevShift.isDefault
            ? { ...prevShift, isDefault: false }
            : prevShift
        );

        state.isDefaultSet = true;
      }

      state.shifts = updatedPrevShifts.map((prevShift) =>
        prevShift.id === updatedShift.id ? updatedShift : prevShift
      );

    },
    deleteShift: (state, action) => {
      const shiftIndex = state.shifts.findIndex((shift) => shift.id === action.payload);
      if (shiftIndex !== -1) {
        state.shifts.splice(shiftIndex, 1);
      }
    },
    setIsDefaultSet: (state, action) => {
      state.isDefaultSet = action.payload;
    },
  },
});

export const { setShifts, addShift, updateShift, deleteShift, setIsDefaultSet } = shiftSlice.actions;

export default shiftSlice.reducer;
